import {useMutation, useQueryClient} from '@tanstack/react-query'
import {followUpService} from '../services/FollowUpService'
import {followUpKeys} from './query-keys'
import type {FollowUpAtualizacaoItemRequest} from '../types'

interface FinalizarConferenciaVariaveis {
  idOrdemCompra: number;
  itens: FollowUpAtualizacaoItemRequest[];
}

export function useFinalizarConferenciaMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    retry: false,
    mutationFn: ({idOrdemCompra, itens}: FinalizarConferenciaVariaveis) =>
      followUpService.atualizarOrdemCompra(idOrdemCompra, itens),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: followUpKeys.ordensCompra()})
      void queryClient.invalidateQueries({queryKey: [...followUpKeys.all, 'itens']})
    },
  })
}
